/**
 * @file format.ts
 * @description Общие форматтеры размеров для админки (phase19.26).
 *
 * Байты приходят с API строками (BigInt в базе) — принимаем и строку, и
 * число. Десятичный разделитель — запятая, как везде в интерфейсе.
 */

/** Число байт или null, если значение пустое/не число. */
function toBytes(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === "") return null;
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

/** Размер человеку: «512 Б», «1,5 МБ», «120 ГБ» (≥ 100 — без дробной части). */
export function formatBytes(value: string | number | null | undefined): string {
  const n = toBytes(value);
  if (n === null) return value === null || value === undefined || value === "" ? "—" : String(value);
  const units = ["Б", "КБ", "МБ", "ГБ", "ТБ"];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  const text = i === 0 ? String(Math.round(v)) : v.toFixed(v >= 100 ? 0 : 1);
  return `${text.replace(".", ",")} ${units[i]}`;
}

/** Всегда в гигабайтах с одним знаком: «37,2 ГБ» (полоска диска, сравнение). */
export function formatGb(value: string | number | null | undefined): string {
  const n = toBytes(value);
  if (n === null) return "—";
  return `${(n / 1024 ** 3).toFixed(1).replace(".", ",")} ГБ`;
}

/** Доля занятого 0..100 для полоски; некорректные данные — 0. */
export function usedPercent(
  used: string | number | null | undefined,
  total: string | number | null | undefined,
): number {
  const u = toBytes(used);
  const t = toBytes(total);
  if (u === null || t === null || t === 0) return 0;
  return Math.min(100, Math.max(0, Math.round((u / t) * 100)));
}
